import Link from "next/link";
import Image from "next/image";
import { getLifeLogoPath } from "@/utils/mnoLogos";

type Props = {
    dimension?: number
}

function Logo({dimension = 60} : Props) {
    return (
        <Link href="/" aria-label="Home" className="flex items-center space-x-2">
            <Image
                src={getLifeLogoPath()}
                alt="Life Logo"
                width={0}
                height={0}
                sizes="100vw"
                style={{width: dimension, height: 'auto'}}
                priority
            />
        </Link>
    );

}

export default Logo;
